module.exports = __webpack_public_path__ + "0a155db43fd329f140a2b68262fec662.png";